import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getAuthenticatedHomePath, hasPermission } from '../../utils/collaboratorPermissions';

const ProtectedRoute = ({ children, allowedRoles = [], requiredPermission = '' }) => {
  const { currentUser, userData, isActive } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (!isActive) {
    return (
      <div className="inactive-account">
        <h2>Conta Inativa</h2>
        <p>Sua conta está aguardando aprovação do administrador.</p>
      </div>
    );
  }

  // Verifica se é colaborador e precisa selecionar empresa
  if (
    userData?.role === 'collaborator' && 
    !userData?.currentCompanyId && 
    location.pathname !== '/select-company'
  ) {
    return <Navigate to="/select-company" />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userData?.role)) {
    return <Navigate to={getAuthenticatedHomePath(userData)} replace />;
  }

  if (requiredPermission && !hasPermission(userData, requiredPermission)) {
    return <Navigate to={getAuthenticatedHomePath(userData)} replace />;
  }

  return children;
};

export default ProtectedRoute;
